import {
  ContractStatusEnum,
  IProperty,
} from "@origin-digital/shared-app-context";

export const prefixPremiseNameIfAccountsClosed = (
  premises?: IProperty[]
): IProperty[] | undefined =>
  premises
    ? premises.map((premise) => ({
        ...premise,
        premiseName: premise.contractAccounts.every(
          (account) => account.status === ContractStatusEnum.CLOSED
        )
          ? `CLOSED - ${premise.premiseName}`
          : premise.premiseName,
      }))
    : undefined;
